<template>
    <div>
        <LoadingOverlay :loading="loading" />
        <div class="weeklyRankRewards-tableSec">
            <div class="weeklyRankRewards-HD">Weekly Ranking Rewards</div>
            <div class="weeklyRankRewards-tableWrap">
                <table>
                    <tbody>
                        <tr v-for="reward in WeeklyRankRewardsAgencyData" :key="reward.id">
                            <td>Top {{ reward.rank }}</td>
                            <td><span><img :src='beansIcon' class="beansIcon" alt="" /></span> {{ reward.reward_coin }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="rankingRewards-ruleCont">
            <ul>
                <li>Agency rank is based on the weekly incomes from all the anchors.</li>
                <li>The ranking updating is subjected to 00:00 (GMT +5:30).</li>
            </ul>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import beansIcon from '../../assets/images/beansIcon.png'
import LoadingOverlay from '../LoadingOverlay.vue'
export default {
    name: 'weeklyRankRewardsAgency',
    components: {
        LoadingOverlay
    },
    data() {
        return {
            WeeklyRankRewardsAgencyData: [],
            beansIcon: beansIcon,
            loading: false
        }
    },
    mounted() {
        this.fetchWeeklyRankRewardsAgencyData();
    },
    methods: {
        fetchWeeklyRankRewardsAgencyData() {
            this.loading= true;
            const tokenParam = this.$route.params.token;
            const token = tokenParam.split('=')[0];
            const apiUrl = `api/top-agency-weekly?type=last_week`;
            axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
                .then(response => {
                    this.WeeklyRankRewardsAgencyData = response.data.result.weeklyrewards;
                })

                .catch(error => {
                    console.error("Error Featching Weekly Data", error)
                })
                .finally(() => {
                    this.loading = false;
                })
        },
    },
}
</script>